<div class="wrap" [class.compact]="isCompact" [class.vertical]="isVertical">
  <div class="decrease" (click)="onDecrease()">
    <img
      src="assets/icon/minus-outlined.svg"
      alt="decrease"
      class="icon"
      [class.disabled]="value === min || disabled"
      [class.icon-actionable]="value > min && !disabled"
    />
  </div>
  <div class="value">{{ value }}</div>
  <div class="increase" (click)="onIncrease()">
    <img
      src="assets/icon/plus-filled.svg"
      alt="increase"
      [class.disabled]="value === max || disabled"
      [class.icon-actionable]="value < max && !disabled"
    />
  </div>
</div>
